module.exports = __webpack_public_path__ + "static/ipad-cover-photo-bcff82899e19e45d515046d185dd3ee2.png";